import { render } from "./UserSectionHeader.vue?vue&type=template&id=3e938bc8&scoped=true"
import script from "./UserSectionHeader.vue?vue&type=script&lang=js"
export * from "./UserSectionHeader.vue?vue&type=script&lang=js"

import "./UserSectionHeader.vue?vue&type=style&index=0&id=3e938bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e938bc8"]])

export default __exports__